import { render } from "./XtokenRedirectView.vue?vue&type=template&id=19b75174"
import script from "./XtokenRedirectView.vue?vue&type=script&lang=js"
export * from "./XtokenRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__